import type { DocNode } from '@atlaskit/adf-schema';
import { type Sources } from '@atlassian/conversation-assistant';

// eslint-disable-next-line no-shadow
export enum FeedbackType {
    POSITIVE = 'positive',
    NEGATIVE = 'negative',
}

export interface LoadingState {
    readonly keywords?: string[];
    readonly sources?: Sources;
}

// eslint-disable-next-line no-shadow
export enum ASSISTANT_MESSAGE_STATUS {
    IDLE = 'idle',
    LOADING_RESPONSE = 'loadingResponse',
    AWAITING_RESPONSE = 'awaitingResponse',
    TYPING_RESPONSE = 'typingResponse',
    ABORTED_RESPONSE = 'abortedResponse',
    SYNCED_RESPONSE = 'syncedResponse',
}

export interface MessageMetadata {
    messageLatency?: number;
    messageId?: string;
    messageFeedback?: {
        feedbackLabel: string;
        detailedFeedback?: string;
        feedbackType: FeedbackType;
    };
    [key: string]: unknown;
    isFallbackMessage?: boolean;
    loadingState?: LoadingState;
    status?: ASSISTANT_MESSAGE_STATUS;
    showFeedback?: boolean;
    isFeedbackSkipped?: boolean;
    isCsatSkipped?: boolean;
    originalQuery?: string;
    csatScore?: number;
}

export interface HelpSeekerMessage {
    readonly userType: 'helpseeker';
    readonly messageContentAdf: DocNode;
    readonly userAccountId?: string | null;
    readonly messageMetadata: MessageMetadata;
}
